import sharedFormatForCode from '../../../../../shared/formatForCode';

formatForCode.$inject = [];

export default function formatForCode() {
    return sharedFormatForCode;
}
